import { render, staticRenderFns } from "./WalletNotificationModal.vue?vue&type=template&id=59f97930&scoped=true&"
import script from "./WalletNotificationModal.vue?vue&type=script&lang=js&"
export * from "./WalletNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletNotificationModal.vue?vue&type=style&index=0&id=59f97930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f97930",
  null
  
)

export default component.exports